import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import ManagedInput from 'components/form/managed_input';

export default function Filter({ label, query, range, name, unitLabel, ...props }) {
  let input;
  if (range) {
    input = <React.Fragment>
      <div className="input-group">
        <div className="input-group-addon">
          {unitLabel}
        </div>
        <ManagedInput
          className="form-control"
          name={`${name}Gteq`}
          value={query[`${name}Gteq`]}
          {...props}
        />
      </div>

      <span className="text-center">to</span>

      <div className="input-group">
        <div className="input-group-addon">
          {unitLabel}
        </div>
        <ManagedInput
          className="form-control"
          name={`${name}Lteq`}
          value={query[`${name}Lteq`]}
          {...props}
        />
      </div>
    </React.Fragment>;
  } else {
    input = (
      <ManagedInput
        className="form-control"
        name={name}
        value={query[name]}
        {...props}
      />
    );
  }

  return (
    <div className={classNames('form-group', { 'form-inline': range, 'range-filter': range })}>
      <h6>{label}</h6>
      {input}
    </div>
  );
}

Filter.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  query: PropTypes.object.isRequired,
  range: PropTypes.bool,
  unitLabel: PropTypes.node,
};
